import React from "react";
import { CircleCheck, CircleX, Loader2 } from "lucide-react";
import { cn } from "@/utils";
import { RISK_STYLES } from "@/constants/riskLevels";
import { ValidationStatus } from "@/hooks/useFieldValidation";

interface ValidationIndicatorProps {
  status: ValidationStatus;
  message?: string;
  details?: string[];
  className?: string;
}

/**
 * Индикатор статуса валидации поля.
 */
const ValidationIndicator: React.FC<ValidationIndicatorProps> = ({ status, message, details, className }) => {
  if (status === "idle") return null;

  return (
    <div className={cn("mt-1", className)}>
      <div className="flex items-center gap-1.5">
        {status === "validating" && (
          <>
            <Loader2 size={14} className="text-primary-500 animate-spin" />
            <span className="text-xs text-ink-3">Проверка...</span>
          </>
        )}
        {status === "valid" && (
          <>
            <CircleCheck size={14} className="flex-shrink-0" style={{ color: RISK_STYLES.A.color }} />
            <span className="text-xs" style={{ color: RISK_STYLES.A.color }}>
              {message}
            </span>
          </>
        )}
        {status === "invalid" && (
          <>
            <CircleX size={14} className="flex-shrink-0" style={{ color: RISK_STYLES.D.color }} />
            <span className="text-xs" style={{ color: RISK_STYLES.D.color }}>
              {message}
            </span>
          </>
        )}
      </div>
      {status === "valid" && details && details.length > 0 && (
        <div className="ml-5 mt-0.5">
          {details.map((detail, index) => (
            <div key={index} className="text-xs text-ink-3">
              {detail}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ValidationIndicator;
